module.exports = __webpack_public_path__ + "static/img/Travis-Boak.14698ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Travis-Boak.jpg
// module id = eTRF
// module chunks = 0